import { InputBaseComponentProps } from '@mui/material';
import React from 'react';
import { NumberFormatValues, NumericFormat } from 'react-number-format';

import { useLocalizedNumericSeparators } from '@/hooks/useLocalizedNumericSeparators';

export const NumericFormatInput: React.FC<
  React.PropsWithoutRef<InputBaseComponentProps> & React.RefAttributes<HTMLInputElement>
> = React.forwardRef(function NumericFormatInput(
  props: InputBaseComponentProps,
  _: React.Ref<HTMLInputElement>,
): React.ReactElement {
  const { decimalSeparator, groupSeparator } = useLocalizedNumericSeparators();
  const { className, 'aria-label': ariaLabel, readOnly, onChange } = props;

  const value = React.useMemo((): number | '' => {
    if (props.value === null) {
      return '';
    }

    if (typeof props.value === 'string') {
      const numeric = Number(props.value);
      if (isNaN(numeric)) {
        return '';
      }

      return numeric;
    }

    return typeof props.value === 'number' ? props.value : '';
  }, [props.value]);

  const allowAll = React.useCallback((values: NumberFormatValues): boolean => {
    const { value } = values;
    return value.length === 0 || !isNaN(Number(value));
  }, []);

  return (
    <NumericFormat
      value={value}
      className={className}
      thousandSeparator={groupSeparator}
      decimalSeparator={decimalSeparator}
      fixedDecimalScale={true}
      decimalScale={2}
      readOnly={readOnly}
      isAllowed={allowAll}
      aria-label={ariaLabel}
      onChange={onChange}
    />
  );
});
